'use strict';

function animateNumbers(element) {
    $(element).find('span').each(function() {
        let desiredValue = $(this).data('value');
        let isDate = $(this).parent().text().indexOf('.') !== -1;

        $(this).prop('Counter', 0).animate({
            Counter: desiredValue
        }, {
            duration: 3000,
            easing: 'swing',
            step: function (now) {
                let newValue = Math.ceil(now);
                $(this).text(isDate ? newValue : newValue.toLocaleString());
            }
        });

    });

    $(element).addClass('animation-done');
}

function elementScrolled(element) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(element).offset().top;
    return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
}

function checkPosition() {
    $('.animated-features-pp .animated-feature__value:not(.animation-done)').each(function() {
        if(elementScrolled($(this))) {
            animateNumbers($(this));
        }
    });
}

export default function animatedFeatures() {

    let selector = '.animated-features-pp .animated-feature__value';

    if ($(selector).length) {

        $(selector).each(function () {
            let value = $(this).text();
            let newValue = value.replace(/\s+/g, '').replace(/([0-9 ]+)/ig, '<span data-value="$1">0</span>');
            $(this).html(newValue);
        });

        checkPosition();

        $(window).scroll(function () {
            checkPosition();
        });

    }

}